import React from 'react';

const Footer = () => {
  return (
    <>
      <footer className="container">
        <div className="row justify-content-center">
          <div className="col-auto">
            &copy; 2024 Alejandro Villanueva
            <span className="visible invisible"></span>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
